import type { IconData } from '@stacksjs/iconify-core'

export const newFolder: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M13.525 4.018c1.932-.154 3.809.669 5.077 2.15l2.042 2.385a4.18 4.18 0 0 0 3.175 1.468h14.944c3.279 0 6.009 2.543 6.118 5.856c.073 2.191.119 4.816.119 7.948c0 7.995-.301 12.683-.573 15.286c-.192 1.838-1.403 3.272-3.195 3.636C38.425 43.318 33.155 44 24 44s-14.425-.682-17.232-1.253c-1.792-.364-3.003-1.798-3.195-3.636C3.3 36.508 3 31.82 3 23.825s.301-12.683.573-15.286C3.765 6.7 4.977 5.266 6.77 4.902c1.489-.303 3.67-.637 6.755-.884\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default newFolder
